<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Asignación de documentos</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-toolbar>
    <v-card>
      <v-container
        fluid
        grid-list-md
      >
        <v-layout row wrap>
          <v-flex xs4>
            <v-select
              v-model="school_filter"
              :items="schools"
              :label="$t('extracurriculares.register.schools')"
              @change="setFilter"
              multiple
              clearable
            ></v-select>
          </v-flex>
          <v-flex xs2>
            <v-select
              v-model="grade_filter"
              :items="grades"
              :label="$t('extracurriculares.register.grades')"
              @change="setFilter"
              multiple
              clearable
            ></v-select>
          </v-flex>
          <v-flex px-2 xs12 sm4>
            <v-select
              :items="documents"
              v-model="filter_document"
              label="Filtrar Documento"
              item-text="name"
              item-value="id"
              clearable
              @change="setFilter"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-container>
      <v-data-table
        class="the-table"
        :headers="tableHeaders"
        :items="tableData"
        :pagination.sync="pagination"
        :search="search"
        :loading="loadingTable"
        :custom-sort="customSort"
        :rows-per-page-text="$t('datatable.rowsPerPageText')"
        :no-results-text="$t('datatable.noResultsText')"
        :no-data-text="$t('datatable.noDataText')"
        :rows-per-page-items="[10,20,50,{'text':$t('datatable.allRowsPerPageItems'),'value':-1}]"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
            >
              <v-icon>arrow_upward</v-icon>
              <div v-if="header.document" class="extra-actions" style="width: 120px; text-align: center;">                
                <span @click="changeSort(header.value)"><b>{{ header.text }}</b></span>
                <br>
                <v-btn
                  small
                  flat
                  icon
                  color="error"
                  class="ma-0 mx-1"
                  title="Desactivar"
                  :loading="isLoading"
                  :disabled="isLoading"
                  @click="promptMassiveAction(header, false)"
                >
                  <v-icon>close</v-icon>
                </v-btn>
                <v-btn
                  small
                  flat
                  icon
                  color="green"
                  class="ma-0 mx-1"
                  title="Activar"
                  :loading="isLoading"
                  :disabled="isLoading"
                  @click="promptMassiveAction(header, true)"
                >
                  <v-icon>check</v-icon>
                </v-btn>
              </div>
              <div v-else style="min-width: 128px">
                <span @click="changeSort(header.value)"><b>{{ header.text }}</b></span>
              </div>
            </th>
          </tr>
        </template>
      <template slot="items" slot-scope="props">
          <td
            v-for="(head, i) in tableHeaders"
            :key="`t-${i}`"
            :class="[head.document || head.value !== 'last_name' ? 'text-xs-center wrap' : 'nowrap']"
          >
            {{ !head.document ? props.item[head.value] : '' }}
            <v-icon
                v-if="head.detail"
                small
                flat
                title="Ver detalle"
                color="blue"
                @click="showFamilyDetail(props.item)"
              >
              info
            </v-icon>
            <v-icon
                v-else-if="head.document && props.item[head.value] && props.item[head.value].split(',')[0] == ''"
                medium
                title="Sin firmar"
                color="grey"
                @click="promptHandleDocumentAsign(props.item.last_name, props.item.family_id, head.id, false, props.item[head.value].split(',')[2])"
              >
              remove_circle
            </v-icon>
            <v-icon
              v-else-if="head.document && props.item[head.value] && props.item[head.value].split(',')[0] == 'F'"
              medium
              title="Firmado"
              color="success"
              @click="promptHandleDocumentAsign(props.item.last_name, props.item.family_id, head.id, false, props.item[head.value].split(',')[2])"
            >
              check_circle
            </v-icon>
            <v-icon
              v-else-if="head.document && props.item[head.value] && props.item[head.value].split(',')[0] == 'P'"
              medium
              title="Pendiente"
              color="warning"
              @click="promptHandleDocumentAsign(props.item.last_name, props.item.family_id, head.id, false, props.item[head.value].split(',')[2])"
            >
              info
            </v-icon>
            <v-icon
              v-else-if="head.document && props.item[head.value] && props.item[head.value].split(',')[0] == 'R'"
              medium
              title="Rechazado"
              color="error"
              @click="promptHandleDocumentAsign(props.item.last_name, props.item.family_id, head.id, false, props.item[head.value].split(',')[2])"
              >
              error
            </v-icon>
            <v-icon
              v-else-if="head.document"
              medium
              title="N/A"
              color="error"
              @click="promptHandleDocumentAsign(props.item.last_name, props.item.family_id, head.id, true)"
              >
              highlight_off
            </v-icon>
          </td>
        </template>
        <template v-slot:pageText="props">
          {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
        </template>
    </v-data-table>
    <v-dialog
        v-model="modalMassiveAction"
        max-width="440"
        persistent
      >
        <v-card>
          <v-card-title class="title red--text text--darken-4">{{ massiveActionText }} Documentos</v-card-title>
          <v-card-text>
            ¿Está seguro de <strong class='red--text'>{{ massiveActionText }} masivamente</strong> el documento <b>{{ selectedDocument ? selectedDocument.text : '' }}</b>?
            <br>
            <br>
            <span>Esta acción se realizará <b>para {{ documentIsAssignedFor(selectedDocument.id) }} familias</b></span>
          </v-card-text>
          <v-card-actions>
            <v-btn 
              @click="handleDocumentMassive(selectedDocument.id, massiveAction)"
              :title="`${ massiveActionText } masivamente`"
              color="red darken-2"
              :loading="isLoading"
              :disabled="isLoading"
              flat>
              Si, {{ massiveActionText }}
            </v-btn>
            <v-btn 
              @click="modalMassiveAction = false"
              title="Cancelar"
              color="grey"
              :loading="isLoading"
              :disabled="isLoading"
              flat>
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="modalItemAction"
        max-width="440"
        persistent
      >
        <v-card>
          <v-card-title class="title red--text text--darken-4">{{ itemActionText }} Documento</v-card-title>
          <v-card-text>
            ¿Está seguro de <strong class='red--text'>{{ itemActionText }}</strong> el documento <b>{{ selectedDocument.id ? selectedDocument.id : '' }}</b> para la familia <b>{{ selectedDocument.family_name }}</b>?
            <span v-if="selectedDocument.assign == false" class="red--text"><br>ADVERTENCIA: Este documento se eliminará completamente</span>
          </v-card-text>
          <v-card-actions>
            <v-btn 
              @click="handleDocumentAsign(selectedDocument.family_id, selectedDocument.document_id, selectedDocument.assign, selectedDocument.id)"
              :title="`${ itemActionText }`"
              color="red darken-2"
              :loading="isLoading"
              :disabled="isLoading"
              flat>
              Si, {{ itemActionText }}
            </v-btn>
            <v-btn 
              @click="modalItemAction = false"
              title="Cancelar"
              color="grey"
              :loading="isLoading"
              :disabled="isLoading"
              flat>
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="modalDetail"
        max-width="540"
      >
        <v-card>
          <v-card-title class="title blue--text text--darken-4">Detalle Familia {{ selectedFamily.last_name }}</v-card-title>
          <v-card-text>
            <table class="table table-bordered table-striped" v-if="Object.keys(selectedFamily).length > 0">
              <tbody>
                <tr><th>#Student</th><td v-for="(id,index) in selectedFamily['student_numbers'].split(',')" :key="id+index">{{ id }}</td></tr>
                <tr><th>Nombre</th><td v-for="(id,index) in selectedFamily['child_names'].split(',')" :key="id+index">{{ id }}</td></tr>
                <tr><th>Grado</th><td v-for="(id,index) in selectedFamily['grade_levels'].split(',')" :key="id+index">{{ grades.find(x => x.value == (id == -1 ? 'K4' : id == 0 ? 'K5' : id)) ? grades.find(x => x.value == (id == -1 ? 'K4' : id == 0 ? 'K5' : id)).text : id }}</td></tr>
                <tr><th>Escuela</th><td v-for="(id,index) in selectedFamily['school_ids'].split(',')" :key="id+index">{{ schools.find(x => x.value == id).text }}</td></tr>
              </tbody>
            </table>
          </v-card-text>
          <v-card-actions>
            <v-btn 
              @click="modalDetail = false"
              color="grey"
              flat>
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'sign-date-employee-documents-view',
    data() {
      return {
        signDateId: '',
        students: [],
        documents: [],
        grade_filter: '',
        school_filter: '',
        schools: [
          { value: 10000, text: 'Early years'},
          { value: 11000, text: 'Elementary School'},
          { value: 12000, text: 'Middle School'},
          { value: 13000, text: 'High School'},
          { value: 14000, text: 'Admissions'},
        ],
        grades: [],
        tableHeaders: [],
        tableData: [],
        originalData: [],
        isLoading: false,
        filter_sign: '',
        filter_document: '',
        search: '',
        loadingTable: false,
        modalMassiveAction: false,
        massiveAction: null,
        selectedDocument: '',
        massiveActionText: '',
        modalItemAction: null,
        itemActionText: '',
        pagination: {
          sortBy: 'last_name'
        },
        modalDetail: false,
        selectedFamily: {}
      }
    },
    computed: {
      
    },
    created () {
      this.signDateId = this.$route.params.id
      this.init();
    },
    methods: {
      init() {
        axios.get(`/api/documents/sign_date/families/report?sign_date_id=${this.signDateId}`)
          .then(resp => {
            if (resp.status === 200) {
              this.students = resp.data.students
              this.documents = resp.data.documents
              this.loadingTable = false
              this.setData()
              this.setFilter()
            }
          })
        
        axios.get('/api/school_grades')
          .then(resp => {
            if (resp.status === 200) {
              resp.data
                .map(grade => this.grades.push({ value: isNaN(parseInt(grade.name)) ? grade.name : parseInt(grade.name), text: grade.name }))
              this.grades.push(
                            { value: -5, text: '-5' },
                            { value: 0, text: '0 (K5)' },
                            { value: -1, text: '-1 (K4)' })
              this.grades.sort((a,b) => a.value - b.value);
            }
          })
      },
      setData() {
        this.loadingTable = true
        let headers = []

        headers.push(
          { text: 'Familia', align: 'start', value: 'last_name', document: false, width: '280px' },
          { text: 'Cód. de fam.', align: 'center', value: 'family_id', document: false },
          { text: 'Cant. Hijos', align: 'center', value: 'childs', document: false, detail: true },
        )

        this.documents.forEach(document => {
          headers.push(
            {
              text: document.name,
              align: 'center',
              value: "doc_"+document.id,
              id: document.id,
              document: true,
              width: "150px",
              orderable: false,
              class: 'wrap',
            }
          )
        })

        this.tableHeaders = headers
        this.loadingTable = false
      },
      setFilter() {
        this.loadingTable = true
        let data = this.students
        if (this.filter_document && this.filter_document !== ""){
          data = data.filter( x => 
            x[`doc_${this.filter_document}`]
          )
        }
        if (Object.keys(this.school_filter).length > 0  ){
          data = data.filter( x => 
            x['school_ids'].split(',').filter(a => 
              this.school_filter.includes(isNaN(parseInt(a)) ? a : parseInt(a))
            ).length > 0
          )
        }
        if (Object.keys(this.grade_filter).length > 0 ){
          data = data.filter( x =>  
            x['grade_levels'].split(',').filter(a => {
                // console.log(this.grade_filter, a, isNaN(parseInt(a)) ? a : parseInt(a))
                return this.grade_filter.includes(isNaN(parseInt(a)) ? a : parseInt(a))
              }
            ).length > 0
          )
        }
        this.tableData = data
        this.loadingTable = false
      },
      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      customSort(items, index, isDescending) {
        items.sort((a, b) => {
          if (a[index] === null) a[index] = ''; else a[index] = ""+a[index];
          if (b[index] === null) b[index] = ''; else b[index] = ""+b[index];
          if (isDescending) {
            try {
              return b[index].localeCompare(a[index]);
            } catch(err) {
              console.error(err)
              return false
            }
          } else {
            try {
              return a[index].localeCompare(b[index]);
            } catch(err) {
              console.error(err)
              return false
            }
          }
        });
        return items;
      },
      promptHandleDocumentAsign(family_name, family_id, document_id, assign, id = null){
        this.modalItemAction = true
        this.itemActionText = assign ? 'Asignar' : 'Eliminar'
        this.selectedDocument = {
            family_name: family_name,
            family_id: family_id,
            document_id: document_id,
            assign: assign,
            id: id,
          }
      },
      showFamilyDetail(data){
        this.modalDetail = true
        this.selectedFamily = data
      },
      handleDocumentAsign(family_id, document_id, assign, id = null) {
        this.loadingTable = true
        const student = this.students.find(fam => fam.family_id === family_id)
        student['id'] = student['ids'].split(',')[0] // toma el primer estudiante de la familia
        const payload = {
          sign_date_id: this.signDateId,
          student,
          document_id,
          assign,
          id,
          assign_type: 'FML',
        }
        axios.post('/api/documents/sign_date/handle_status', payload)
          .then(resp => {
            if (resp.status === 200) {
              this.init()
              this.$store.dispatch('responseMessage', { type: 'success', text:  `Acción realizada correctamente` })
              this.isLoading = false
              this.modalItemAction = false
              this.loadingTable = false
            }
          })
          .catch(err => {
            this.$store.dispatch('responseMessage', { type: 'error', text:  `Ocurrió un error, reintente nuevamente` })
            this.isLoading = false
            this.loadingTable = false
            console.log(err)
          })
      },
      documentIsAssignedFor(document_id) {
        if(document_id){
          let records = []
          if (this.massiveAction){
            records = this.tableData.filter(sign => !sign[`doc_${document_id}`] || sign[`doc_${document_id}`].split(',')[0] == 'R')
          } else {
            records = this.tableData.filter(sign => sign[`doc_${document_id}`])
          }
          return records.length
        }
      },
      promptMassiveAction(document, assign) {
        this.modalMassiveAction = true
        this.selectedDocument = document
        this.massiveAction = assign
        this.massiveActionText = assign ? 'Asignar' : 'Eliminar'
      },
      handleDocumentMassive(document_id, assign) {
        this.loading = true
        this.loadingTable = true
        let filtered_items = []
        if (assign){
          filtered_items = this.tableData.filter(x => !x[`doc_${document_id}`])
        } else {
          filtered_items = this.tableData.filter(x => x[`doc_${document_id}`])
        }
        const payload = {
          sign_date_id: this.signDateId,
          document_id,
          assign,
          assign_type: 'FML',
          student_ids: filtered_items.map(stu => ({ student_id : stu['ids'].split(',')[0], family_id : stu['family_id'] })),
        }
        axios.post('/api/documents/sign_date/handle_status/massive', payload)
          .then(resp => {
            if (resp.status === 200) {
              this.isLoading = false
              this.loadingTable = false
              this.modalMassiveAction = false
              this.$store.dispatch('responseMessage', { type: 'success', text:  `Acción realizada correctamente` })
              this.init()
            }
          })
          .catch(err => {
            this.$store.dispatch('responseMessage', { type: 'error', text:  `Ocurrió un error, reintente nuevamente` })
            this.isLoading = false
            this.loadingTable = false
            console.log(err)
          })
      }
    },
  }
</script>

<style lang="scss" scoped>
.table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 20px;
}
table {
    border-collapse: collapse;
    border-spacing: 0;
}
.table-striped>tbody>tr:nth-of-type(odd) {
    background-color: #f9f9f9;
}
.table>tbody>tr>td, .table>tbody>tr>th, .table>tfoot>tr>td, .table>tfoot>tr>th, .table>thead>tr>td, .table>thead>tr>th {
    padding: 8px;
    line-height: 1.42857143;
    vertical-align: top;
    border-top: 1px solid #ddd;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/documents/family_documents.vue